/* 中文词典：menu 命名空间。见 src/i18n/README.md。 */

import type { TextSpec } from '../text';

const menu = {
  // ---- 标题页 ----
  'title.header': ['标题画面'],
  'title.netplay': ['联机对局'],
  'title.hotseat': ['本地对局（热座）'],
  'title.debug': ['调试页'],

  // ---- 更新日志页（标题页 · 鸣谢按钮上方进入）----
  'changelog.framework': ['游戏基本框架'],
  'changelog.loreRichText': ['结构化文本系统'],
  'changelog.platformAdaptation': ['多平台适配'],

  // ---- 联机汇合页 ----
  'meetup.roomCode': ['房间号（', { type: 'param', name: 'n' }, ' 位）'],
  'meetup.join': ['确认加入'],
  'meetup.changeNickname': ['在设置页修改昵称'],

  // ---- 正在连接页 ----
  'connecting.header': ['连接中'],
  'connecting.joinPanel': ['加入房间'],
  'connecting.roomCode': ['房间号 ', { type: 'param', name: 'code' }],
  'connecting.probing': ['正在连接信令网络…'],
  'connecting.searching': ['正在寻找房间…'],
  'connecting.ready': ['已连接'],
  'connecting.failed': ['连接失败'],
  'connecting.idle': ['未连接'],
  'connecting.returning': ['正在返回'],
  'connecting.cancel': ['取消'],

  // ---- 对局右下角按钮 ----
  'table.agree': ['同意'],
  'table.giveUp': ['放弃'],
  'table.endExtraTurn': ['结束额外回合'],
  // ---- 画面中央的出牌选择（目标 / 目标+牌名）----
  'table.chooseTarget': ['选择目标'],
  'table.chooseTargetAndName': ['选择目标与牌名'],

  // ---- 动作按钮的 hover 说明（按下去会发生什么）----
  'table.endTurn.common': ['抽一张牌并结束回合。'],
  'table.endTurn.tip': [
    { type: 'key', key: 'table.endTurn.common' },
    '\n随后，行动权将交给下一位玩家。'
  ],
  'table.endExtraTurn.tip': [
    { type: 'key', key: 'table.endTurn.common' },
    '因来自其他玩家的',
    { type: 'param', name: 'card' },
    '，仍需进行',
    { type: 'param', name: 'count' },
    '个回合。\n',
  ],
  'table.agree.tip': ['放弃打断机会，交出一张', { type: 'param', name: 'card' }],
  'table.giveUp.tip': ['放弃复活机会，主动输掉游戏。'],

  // ---- 导出文件 ----
  'transfer.unsupported': ['当前环境不支持导出文件'],
  'transfer.failed': ['导出失败'],

  // ---- 房间配置导入 ----
  'preset.invalidJson': ['无法解析数据，文件可能已损坏。'],
  'preset.wrongKind': ['无法在文件中找到房间配置数据。'],
  'preset.tooNew': ['这份配置来自更新的游戏版本，请刷新页面。'],

  // ---- 连接 / 会话 ----
  'connect.offline': ['无法连接网络。'],
  'connect.relayUnreachable': ['无法连接信令中继。'],
  'connect.roomNotFound': ['未找到房间。'],
  'connect.networkUnreachable': ['无法连接至网络。'],
  'session.kicked': ['被房主移出了房间。'],
  'session.notInRoom': ['未进入房间。'],

  // ---- 入口 ----
  'main.rendererFatal': [
    '无法渲染画面.\n',
    '您的浏览器或设备不支持此游戏使用的渲染技术。'
  ],
  'main.rotateHint': ['请横屏使用'],
  // ---- 开发者诊断（玩家看不到，但同样集中管理） ----
  'main.logRelayProbeFailed': ['[s3] 中继探测失败：房间号'],
  'main.logRelayConfigured': ['[s3] 信令中继（配置）：'],
  'main.logActualSocket': ['\n[s3] 实际 socket：'],
  'main.logNoPeer': ['[s3] 未找到对端。本机中继：'],
  'main.logTurnConfigured': ['[s3] TURN 已配置：'],
  'main.logTurnFailed': ['[s3] TURN 凭据获取失败，本次只用 STUN：'],
  'main.logBgmStartFailed': ['[bgm] 起播失败：'],
  'screenHost.unknownScreen': ['没有注册过这个屏幕：', { type: 'param', name: 'id' }, '。'],
  'screenHost.unknownScreenHint': ['屏幕工厂要先 define() 再 start()（见 ScreenHost.start 的说明）'],
  'stack.empty': ['菜单栈里一个屏幕都没有 —— 根屏幕不该被弹出'],
  'beat.subscriberThrew': ['[beat] 音乐事件的订阅者抛了异常'],
} as const;
menu satisfies Record<string, TextSpec>;
export default menu;
